module.exports = __webpack_public_path__ + "static/media/manuel2.0e48a63f.png";